<template>
  <header id="c-header" class="c-header" :class="{'c-header--show-menu': isShowNav}">
    <Transition name="c-header">
    <div v-show="isShowMenu" class="c-header__menu c-btn c-btn--menu" @click="openMenu"></div>
    </Transition>
  </header>
</template>

<script>

export default {
  data() {
    return {}
  },
  computed: {
    isShowNav() {
      return this.$store.getters.showNav;
    },
    isShowMenu() {
      return this.$store.getters.showMenu;
    }
  },
  mounted() {
  },
  methods: {
    openMenu() {
      if (this.isShowNav) {
        this.$store.commit('showNav', false);
      } else {
        this.$store.commit('showNav', true);
      }
    }
  }
}

</script>